import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateStatus } from '../api/updateStatus';
import { AccordionListItem } from 'components/Button';
import { Button, Stack, Typography } from '@mui/material';
import { Modal } from 'components/Modal';

export const StatusToggleButton = ({ status, refetch }) => {
  const { id } = useParams();
  const { mutateAsync } = useUpdateStatus(refetch);

  const [open, setOpen] = useState(false);

  const handleCloseModal = () => setOpen(false);

  const handleStatusUpdate = () =>
    mutateAsync({
      jobAdID: id,
      status: status === 'active' ? 'withdrawn' : 'active',
    })
      .then(handleCloseModal)
      .catch(() => {});

  return (
    <>
      <AccordionListItem onClick={() => setOpen(true)}>
        {status === 'active' ? 'Withdraw' : 'Activate'}
      </AccordionListItem>

      <Modal open={open} handleClose={handleCloseModal} title="Status update">
        <Typography variant="body1" fontWeight={500}>
          Are you sure you want to set the status to{' '}
          <span style={{ fontWeight: 'bold' }}>
            {status === 'active' ? 'withdrawn' : 'active'}?{' '}
          </span>
        </Typography>

        <Stack direction="row" justifyContent="center" gap={1}>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleStatusUpdate}>
            Confirm
          </Button>
        </Stack>
      </Modal>
    </>
  );
};
